import { postCsvUpload } from './postCsvUpload';
import { getCsvList } from './getCsvList';
import { getCsvZip } from './getCsvZip';
import { putCsvZip } from './putCsvZip';
import { getCsvUsers } from './getCsvUsers';
import { getCsvTenants } from './getCsvTenants';
import { getCsvExternalIdpSaml } from './getCsvExternalIdpSaml';
import { getCsvZipHubUploadBatchList } from './getCsvZipHubUploadBatchList';
import { postCsvTenants } from './postCsvTenants';
import { postCsvUsers } from './postCsvUsers';
import { postCsvExternalIdpSaml } from './postCsvExternalIdpSaml';
import { postCsvZipHubUpload } from './postCsvZipHubUpload';
import { patchCsvZipHubUpload } from './patchCsvZipHubUpload';
import { postCsvExternalIdpOidc } from './postCsvExternalIdpOidc';
import { getCsvExternalIdpOidc } from './getCsvExternalIdpOidc';
import { postCsvProductInstances } from './postCsvProductInstances';
import { getCsvProductInstances } from './getCsvProductInstances';
import { patchCsvZipHubUploadBatchStatus } from './patchCsvZipHubUploadBatchStatus';

export default {
  postCsvUpload,
  getCsvZip,
  putCsvZip,
  getCsvList,
  getCsvUsers,
  getCsvTenants,
  getCsvExternalIdpSaml,
  getCsvZipHubUploadBatchList,
  postCsvTenants,
  postCsvUsers,
  postCsvExternalIdpSaml,
  patchCsvZipHubUpload,
  postCsvZipHubUpload,
  postCsvExternalIdpOidc,
  getCsvExternalIdpOidc,
  postCsvProductInstances,
  getCsvProductInstances,
  patchCsvZipHubUploadBatchStatus
};
